export default "__VITE_ASSET__C9tvC9Cl__"